import type { AssessmentDetails } from "@core/assessments/types";
import { Attachment } from "./attachment.entity";

export type ResourceLockReason = "assessmentNotFinished" | "reachedMaxViews";
export type Resource = {
  id: number;
  url: string;
  type: ResourceType;
  duration?: number;
  title?: string;
  category?: string;
  description?: string;
  assessment?: AssessmentDetails;
  isLocked?: boolean;
  lockReason?: ResourceLockReason;
  linkedResource?: Resource;
  linkedResources?: Resource[];
  maxViews?: number;
  viewsCount?: number;
  /**
   * Remaining allowed views (max(0, maxViews - viewsCount)), only present when a view limit applies
   */
  remainingViews?: number;
  image: Attachment;
};

export enum ResourceType {
  Image = "image",
  Pdf = "pdf",
  Video = "video",
  Audio = "audio",
  File = "file",
  Xlsx = "xlsx",
  Docx = "docx",
  Pptx = "pptx",
  Youtube = "youtube",
  Url = "url",
  Assessment = "assessment",
}
